import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ErrorActions } from './error.actions';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ROUTER_NAVIGATED } from '@ngrx/router-store';

@Injectable({
	providedIn: 'root',
})
export class ErrorEffects {
	constructor(private actions$: Actions<any>) {}

	navigated$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ROUTER_NAVIGATED),
			switchMap(() => of(ErrorActions.error.hide()))
		)
	);
}
